<template>
  <b-tabs
    vertical
    content-class="col-12 col-md-9 mt-1 mt-md-0"
    pills
    nav-wrapper-class="col-md-3 col-12"
    nav-class="nav-left"
  >
    <b-tab
      disabled
    >
      <template #title>
        <span class="font-weight-bold">Account Settings</span>
      </template>
    </b-tab>
    <!-- general tab
    <b-tab active>

      <template #title>
        <feather-icon
          icon="UserIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">General</span>
      </template>
      <account-setting-general
        v-if="options.general"
        :general-data="options.general"
      />
    </b-tab>
general tab -->

    <!-- change password tab -->
    <b-tab>

      <!-- title -->
      <template #title>
        <feather-icon
          icon="LockIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Change Password</span>
      </template>
      <account-setting-password />
    </b-tab>
    <!--/ change password tab -->

    <!-- My Sites
    <b-tab>

      <template #title>
        <feather-icon
          icon="HeartIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">My Sites</span>
      </template>
      <account-setting-sites />
    </b-tab>
      My Sites -->

    <!-- notification
    <b-tab>

      <template #title>
        <feather-icon
          icon="BellIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Notifications</span>
      </template>

      <account-setting-notification
        v-if="options.notification"
        :notification-data="options.notification"
      />
    </b-tab>
    notification -->

    <!-- workspace settings -->
    <!-- only admin can see workspace settings --->
    <Can
      i="manage"
      a="workspace"
    >
      <b-tab
        disabled
      >
        <template #title>
          <span class="font-weight-bold">Workspace Settings</span>
        </template>
      </b-tab>

      <!-- a tab for workspace information -->
      <b-tab>
        <!-- title -->
        <template #title>
          <feather-icon
            icon="InfoIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">Workspace Details</span>
        </template>
        <workspace-details />
      </b-tab>

      <!-- a tab for configuring networks -->
      <b-tab>
        <!-- title -->
        <template #title>
          <feather-icon
            icon="WifiIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">Networks & Connectivity Partners</span>
        </template>
        <workspace-networks />
      </b-tab>

      <!-- a tab for listing users in the workspace -->
      <b-tab>
        <template #title>
          <feather-icon
            icon="UsersIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">Users</span>
        </template>
        <workspace-users />
      </b-tab>

      <!-- a tab for device settings in the workspace -->
      <b-tab>
        <template #title>
          <feather-icon
            icon="SettingsIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">Devices</span>
        </template>
        <workspace-devices />
      </b-tab>

      <!-- a tab for objects settings in the workspace -->
      <b-tab>
        <template #title>
          <feather-icon
            icon="BoxIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">Objects</span>
        </template>
        <workspace-objects />
      </b-tab>

      <!-- a tab for site settings in the workspace -->
      <b-tab>
        <template #title>
          <feather-icon
            icon="MapPinIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">Sites</span>
        </template>
        <workspace-sites />
      </b-tab>

    </Can>
  </b-tabs>

</template>

<script>

import {
  BTabs, BTab,
} from 'bootstrap-vue'
import { API } from 'aws-amplify'
import { Can } from '@casl/vue'
// import AccountSettingGeneral from './AccountSettingGeneral.vue'
import AccountSettingPassword from './AccountSettingPassword.vue'
// import AccountSettingSites from './AccountSettingSites.vue'
// import AccountSettingNotification from './AccountSettingNotification.vue'
// Workspace Settings
import WorkspaceDetails from './WorkspaceDetails.vue'
import WorkspaceNetworks from './WorkspaceNetworks/WorkspaceNetworks.vue'
import WorkspaceUsers from './WorkspaceUsers.vue'
import WorkspaceObjects from './WorkspaceObjects.vue'
import WorkspaceDevices from './WorkspaceDevices.vue'
import WorkspaceSites from './WorkspaceSites.vue'
// import WorkspaceBilling from './WorkspaceBilling.vue'

import * as queries from '../../graphql/queries'

export default {
  components: {
    // bootstrap-vue
    BTabs,
    BTab,
    // Account
    // AccountSettingGeneral,
    AccountSettingPassword,
    // AccountSettingSites,
    // AccountSettingNotification,
    // Workspace
    WorkspaceDetails,
    WorkspaceNetworks,
    WorkspaceUsers,
    WorkspaceObjects,
    WorkspaceDevices,
    WorkspaceSites,
    // WorkspaceBilling,
    Can,
  },
  data() {
    return {
      siteTypes: [],
      validTags: [],
      invalidTags: [],
      duplicateTags: [],
      options: {},
    }
  },
  beforeCreate() {

    // this.$http.get('/account-setting/data').then(res => { this.options = res.data })
  },
  created() {
    this.listTypes()
  },
  methods: {
    async listTypes() {
      await API.graphql({
        query: queries.listTypes,
      }).then(response => {
        response.data.listTypes.items.forEach(type => {
          this.siteTypes.push(type.id)
        })
      })
    },
    onTagState(valid, invalid, duplicate) {
      this.validTags = valid
      this.invalidTags = invalid
      this.duplicateTags = duplicate
    },
  },

}
</script>
